<!--获取云停车场收费规则信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodes": "PRJ2EBMY,PR32HQ12,2KKN6112"
            },
            responseCode: 	{
                "data": {
                    "parkChargeBaseVoMap": {
                        "2KKN6112": [
                            {
                                "chargeTypeSeq": 1,
                                "typeName": "默认收费组"
                            },
                            {
                                "chargeTypeSeq": 0,
                                "typeName": "test计费组2"
                            }
                        ],
                        "PRJ2EBMY": [
                            {
                                "chargeTypeSeq": 0,
                                "typeName": "默认计费规则"
                            }
                        ],
                        "PR32HQ12": [
                            {
                                "chargeTypeSeq": 0,
                                "typeName": "默认收费组"
                            }
                        ]
                    }
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取云停车场收费规则信息",
                t_url: this.commonUrls.test+"getCloudParkChargeInfoMap",
                p_url: this.commonUrls.prod+"getCloudParkChargeInfoMap",
                precondition: "",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodes', info2: '是', info3: 'String', info4: '停车场编号组，‘,’分隔' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkChargeBaseVoMap', info2: '是', info3: 'JSONObject', info4: '缴费组map' }
                        ]
                },{
                    titleName: 'parkChargeBaseVoMap',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'chargeTypeSeq', info2: '是', info3: 'Integer', info4: '缴费类型流水号。0为默认计费规则编号' },
                        { info1: 'typeName', info2: '否', info3: 'String', info4: '缴费类型名称' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/trade/getCloudParkChargeInfoMap.vue